import type { TeacherProfileWithRelations } from '@/app/(teacher)/profile/_actions/types';
import type { Institution } from '@/features/server/actions/rbac/types';
import type { TeacherProfileData } from './types';

export default function teacherProfileToStore(teacherProfile: TeacherProfileWithRelations): TeacherProfileData {
  const profileInstitutions = teacherProfile.institutions ?? [];

  // Map institution IDs and custom names
  const institutionIds = profileInstitutions
    .map(({ institution_id, custom_name }) => institution_id || custom_name || '')
    .filter((id) => id.length > 0);

  // Map to institution objects for display
  const institutions = profileInstitutions
    .filter(({ institution }) => !!institution)
    .map(({ institution: i }) => {
      const institution = i as Institution;
      return {
        id: institution.id,
        name: institution.name,
        city: institution.city || undefined,
        type: institution.type,
        state_province: institution.state_province || undefined,
        postal_code: institution.postal_code || undefined,
        country_code: institution.country_code,
      };
    });

  return {
    selectedProfessionId: teacherProfile.profession_id ?? undefined,
    city: teacherProfile.city ?? undefined,
    stateProvince: teacherProfile.state_province ?? undefined,
    countryCode: teacherProfile.country_code ?? undefined,
    selectedInstitutions: institutions,
    selectedInstitutionIds: institutionIds,
    selectedGrades: (teacherProfile.grades ?? []).map(({ grade_id }) => grade_id),
    selectedSubjects: (teacherProfile.subjects ?? []).map(({ subject_id, custom_name }) => subject_id || custom_name || ''),
    customSubject: (teacherProfile.subjects ?? []).find(({ custom_name }) => custom_name)?.custom_name ?? undefined,
    profileComplete: !!teacherProfile.profile_completed_at,
  };
}
